import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, Body1, Body2, ListSeparator } from "@activecollab/components";
import { getCombinedRecords, getAmountAvailable } from "~/store/selectors/selector.accountBalance";
import { roundAmount } from "~/utils/utils";

const BalanceTooltipContent = () => {
  const { t } = useTranslation();
  const records = useSelector((state) => getCombinedRecords(state));
  const total = useSelector((state) => getAmountAvailable(state));

  const renderBalanceRecord = (record) => {
    return (
      <div
        className="tw-flex tw-justify-between"
        data-testid="balance-records"
      >
        <Body2 color="tertiary">{record.reason}</Body2>
        {record.reason_details ? <Body2 color="tertiary">{record.reason_details}</Body2> : null}
        <Body2
          color="secondary"
          weight="bold"
          className="tw-ml-6"
        >
          ${roundAmount(record.amount_available)}
        </Body2>
      </div>
    );
  };

  return (
    <>
      {records.map((record, index) => {
        return <div key={index}>{renderBalanceRecord(record)}</div>;
      })}
      <ListSeparator className="tw-mx-[-16px]" />
      <div className="tw-flex tw-justify-between">
        <Body1
          color="secondary"
          weight="bold"
        >
          {t("Total")}
        </Body1>
        <Body1
          color="secondary"
          weight="bold"
          data-testid="balance-total-amount"
        >
          ${roundAmount(total)}
        </Body1>
      </div>
      <ListSeparator className="tw-mx-[-16px]" />
      <Caption1 color="secondary">{t("This amount will be subtracted from your next payment")}.</Caption1>
    </>
  );
};

export default BalanceTooltipContent;
